import { render } from "./QuartlyProductionComponent.vue?vue&type=template&id=b9ffe848&scoped=true"
import script from "./QuartlyProductionComponent.vue?vue&type=script&lang=ts"
export * from "./QuartlyProductionComponent.vue?vue&type=script&lang=ts"

import "./QuartlyProductionComponent.vue?vue&type=style&index=0&id=b9ffe848&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9ffe848"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QCardSection,QForm,QSelect,QItem,QItemSection,QItemLabel,QIcon,QTooltip,QInput,QCheckbox,QDialog,QCardActions});qInstall(script, 'directives', {ClosePopup});
